mutation StartYouTubeChatSession($eventId: ID, $videoUrl: String) {
  result: StreamToolsStartYouTubeChatSession(eventId: $eventId, videoUrl: $videoUrl) {
    started
    refusalCode
    message
    session {
      sessionId
      eventId
      scope
      status
      startedAt
      stoppedAt
      stopReason
      channelId
      channelTitle
      videoId
      channelProfileImageUrl
      foreignEvent
    }
  }
}
